import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("sbb_token", data.token);
      toast.success(`Selamat datang, ${data.user.name}!`);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-sm border border-brand-gold/30 bg-white px-4 py-3.5 text-sm text-brand-ink outline-none transition-colors focus:border-brand-gold focus:ring-1 focus:ring-brand-gold/40";

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-brand-burgundy px-5">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <p className="font-cinzel text-2xl font-bold tracking-[0.18em] text-brand-cream">
            SALON <span className="text-brand-gold">STRAWBERRY</span>
          </p>
          <p className="mt-2 text-[10px] uppercase tracking-[0.35em] text-brand-cream/50">Admin Portal</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-sm bg-brand-cream p-8 shadow-2xl gold-foil-border sm:p-10">
          <div className="mb-7 flex items-center gap-3">
            <Lock size={18} className="text-brand-gold" />
            <h1 className="font-serif text-xl font-semibold text-brand-burgundy">Masuk Dashboard</h1>
          </div>
          <label className="mb-2 block text-xs font-semibold uppercase tracking-[0.18em] text-brand-burgundy">Email</label>
          <input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required autoComplete="email" />
          <label className="mb-2 mt-5 block text-xs font-semibold uppercase tracking-[0.18em] text-brand-burgundy">Password</label>
          <input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required autoComplete="current-password" />
          <button
            data-testid="admin-login-submit-btn"
            type="submit"
            disabled={loading}
            className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-brand-burgundy py-4 text-xs font-bold uppercase tracking-[0.22em] text-brand-cream transition-all duration-300 hover:bg-brand-gold hover:text-brand-ink disabled:opacity-60"
          >
            <LogIn size={15} /> {loading ? "Memproses..." : "Masuk"}
          </button>
        </form>
      </div>
    </div>
  );
}
